import { createFileRoute } from '@tanstack/react-router'
import { LegalNoticesPage } from '@/pages/LegalNoticesPage'

const App = () => {
  return <LegalNoticesPage />
}

export const Route = createFileRoute('/legal-notices')({
  component: App,
})
